module.exports = __webpack_public_path__ + "images/psp/SelfStorage/shutterstock_694770004-scaled.jpg";